import { createGlobalStyle } from 'styled-components';
import { scriptTypography } from './typography';

export default createGlobalStyle`
  :root {
    --b-black: #000000;
    --b-white: #ffffff;
    --b-ink: #1c1c1c;
    --b-graphite: #2d2f2e;
    --b-coal: #2d2d2a;
    --b-fog: #f0f0f0;
    --b-silver: #d3d3d3;
    --b-smoke: #e8e8e8;
    --b-lavender-grey: #c9c9d5;
    --b-lilac: #b6a0eb;
    --b-sky: #01bcff;
    --b-mint: #02f293;
    --b-pink: #f9a8cc;
    --b-periwinkle: #b3d0ff;
    --b-aqua: #00dfe6;
    --b-light-blue: #63cbff;
    --b-mist: #d9e5e7;

    --ff-sans: 'Pretendard', 'Pretendard Variable', -apple-system, BlinkMacSystemFont, system-ui,
      'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;

    --b-gutter: 20px;
    --b-radius: 8px;
    --b-radius-s: 3px;

    --piano-base: 1rem;
    --piano-boost: 0rem;

    --size-1200: calc((var(--piano-base) * 3.0314 + var(--piano-boost) * 7.5) * var(--size-scale-1200, 1));
    --size-1100: calc((var(--piano-base) * 2.639 + var(--piano-boost) * 5) * var(--size-scale-1100, 1));
    --size-1000: calc((var(--piano-base) * 2.2974 + var(--piano-boost) * 3.1 + 0.0625rem) * var(--size-scale-1000, 1));
    --size-900: calc((var(--piano-base) * 2.1435 + var(--piano-boost) * 2.6) * var(--size-scale-900, 1));
    --size-800: calc((var(--piano-base) * 1.8661 + var(--piano-boost) * 1.6) * var(--size-scale-800, 1));
    --size-700: calc((var(--piano-base) * 1.6245 + var(--piano-boost)) * var(--size-scale-700, 1));
    --size-600: calc((var(--piano-base) * 1.5157 + var(--piano-boost) * 0.7) * var(--size-scale-600, 1));
    --size-500: calc((var(--piano-base) * 1.3195 + var(--piano-boost) * 0.3) * var(--size-scale-500, 1));
    --size-400: calc((var(--piano-base) * 1.1487) * var(--size-scale-400, 1));
    --size-300: calc(var(--piano-base) * var(--size-scale-300, 1));
    --size-200: calc((0.89rem + (var(--piano-base) - 1rem) * 0.65) * var(--size-scale-200, 1));
    --size-100: calc((0.825rem + (var(--piano-base) - 1rem) * 0.375) * var(--size-scale-100, 1));
    --size-00: calc((0.75rem + (var(--piano-base) - 1rem) / 6) * var(--size-scale-00, 1));
  }

  :root:lang(ko) {
    --ff-sans: 'Pretendard', 'Pretendard Variable', -apple-system, BlinkMacSystemFont,
      'Apple SD Gothic Neo', 'Malgun Gothic', 'Noto Sans KR', system-ui, sans-serif;
  }

  :root:lang(ja) {
    --ff-sans: 'Pretendard JP', 'Pretendard', -apple-system, BlinkMacSystemFont, 'Hiragino Sans',
      'Hiragino Kaku Gothic ProN', 'Yu Gothic', 'Noto Sans JP', Meiryo, system-ui, sans-serif;
  }

  ${scriptTypography}

  @media (min-width: 480px) {
    :root {
      --piano-base: 1rem;
      --piano-boost: calc((100vw - 30rem) * 0.017);
    }
  }

  @media (min-width: 768px) {
    :root {
      --piano-base: calc(1rem + (100vw - 48rem) * 0.0075);
      --piano-boost: calc(0.306rem + (100vw - 48rem) * 0.012);
    }
  }

  @media (min-width: 992px) {
    :root {
      --piano-base: calc(1.105rem + (100vw - 62rem) * 0.006);
      --piano-boost: calc(0.474rem + (100vw - 62rem) * 0.0075);
    }
  }

  @media (min-width: 1440px) {
    :root {
      --piano-base: calc(1.273rem + (100vw - 90rem) * 0.0034);
      --piano-boost: calc(0.684rem + (100vw - 90rem) * 0.012);
    }
  }

  @media (min-width: 1920px) {
    :root {
      --piano-base: 1.375rem;
      --piano-boost: 1.044rem;
    }
  }
`;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/styles/brand.js